<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-thermal-invoice-page" [class.bb-thermal-mode]="receipt" dir="rtl">
  <div class="bb-thermal-invoice">

    <div class="bb-thermal-actions noPrint">
      <button type="button" class="bb-btn bb-btn-primary" (click)="enableCardPrintAndPrint()">
        {{ 'طباعة الفاتورة' | transloco }}
      </button>
    </div>

    <div class="bb-thermal-header">
      <img
        class="bb-thermal-logo"
        [defaultImage]="'/assets/loading-in.gif'"
        [lazyLoad]="userimage"
        [errorImage]="'/assets/logo-01.png'"
        [alt]="'logo' | transloco"
      />

      <h1 class="bb-thermal-title">{{ 'فاتورة' | transloco }}</h1>

      <div class="bb-thermal-meta">
        <p>{{ 'رقم الفاتورة:' | transloco }} {{ invoiceId }}</p>
        <p>{{ 'التاريخ:' | transloco }} {{ date }}</p>
      </div>
    </div>

    <div class="bb-thermal-section">
      <div class="bb-thermal-simple-line">
        <span>{{ 'من:' | transloco }}</span>
      </div>

      <h2 class="bb-thermal-section-title">{{ pagename }}</h2>

      <div class="bb-thermal-lines">
        <p *ngIf="facebook">{{ facebook }}</p>
        <p *ngIf="instagram">{{ instagram }}</p>
        <p *ngIf="tiktok">{{ tiktok }}</p>
        <p *ngIf="website">{{ website }}</p>
        <p *ngIf="userphone">{{ userphone }}</p>
      </div>
    </div>

    <div class="bb-thermal-section">
      <div class="bb-thermal-simple-line">
        <span>{{ 'إلى:' | transloco }}</span>
      </div>

      <h3 class="bb-thermal-customer-name">{{ clientname }}</h3>

      <div class="bb-thermal-customer-extra" *ngIf="firstphone || address || grov?.governorate_name_ar || city?.city_name_ar">
        <p *ngIf="firstphone">{{ firstphone }}</p>

        <p *ngIf="grov?.governorate_name_ar || city?.city_name_ar">
          {{ grov?.governorate_name_ar }} {{ city?.city_name_ar ? '- ' + city?.city_name_ar : '' }}
        </p>

        <p *ngIf="address">{{ address }}</p>
      </div>
    </div>

    <div class="bb-thermal-items">
      <div class="bb-thermal-items-head">
        <div class="bb-thermal-col-name">{{ 'المنتج' | transloco }}</div>
        <div class="bb-thermal-col-qty">{{ 'الكمية' | transloco }}</div>
        <div class="bb-thermal-col-price">{{ 'السعر' | transloco }}</div>
        <div class="bb-thermal-col-total">{{ 'الإجمالي' | transloco }}</div>
      </div>

      <div class="bb-thermal-items-body">
        <div class="bb-thermal-item-row" *ngFor="let product of products; let i = index">
          <div class="bb-thermal-col-name bb-thermal-product-text">{{ products[i] }}</div>
          <div class="bb-thermal-col-qty">{{ qty[i] }}</div>
          <div class="bb-thermal-col-price">{{ prices[i] }}</div>
          <div class="bb-thermal-col-total">{{ prices[i] * qty[i] }}</div>
        </div>
      </div>
    </div>

    <div class="bb-thermal-summary">
      <div class="bb-thermal-summary-row" *ngIf="discount && discount > 0">
        <span>{{ 'الخصم' | transloco }}</span>
        <strong>{{ discount }} {{ 'ج.م' | transloco }}</strong>
      </div>

      <div class="bb-thermal-summary-row" *ngIf="deliveryfees && deliveryfees > 0">
        <span>{{ 'التوصيل' | transloco }}</span>
        <strong>{{ deliveryfees }} {{ 'ج.م' | transloco }}</strong>
      </div>

      <div class="bb-thermal-summary-row bb-thermal-total-row">
        <span>{{ 'الإجمالي' | transloco }}</span>
        <strong>{{ (sumprices - discount) + (deliveryfees || 0) }} {{ 'ج.م' | transloco }}</strong>
      </div>
    </div>

    <div class="bb-thermal-qr" *ngIf="qrPath && !receipt">
      <img [src]="fixImageUrl(qrPath)" [alt]="'QR Code' | transloco" />
      <p *ngIf="link">{{ link }}</p>
    </div>

    <div class="bb-thermal-footer">
      <p>{{ 'شكرًا لاختيارك' | transloco }} {{ pagename }}</p>
    </div>

  </div>
</section>